import { graphql } from 'gql';

export const bimWorkOrderChangeObjectsGql = graphql(`
    query bimWorkOrderChangeObjects($workOrderChangeId: Long!) {
        bimWorkOrderChangeObjects(workOrderChangeId: $workOrderChangeId) {
            items {
                workOrderObjectId
                workOrderChangeObjectId
                constructionTypeId
                isRootObject
                fromWorkOrder
                fromWorkOrderChange
                isActKC2Object
                isAddedObject
                isRemovedObject
                canSetGuaranteedVolume
                isExcludedObject
                hasChildren
                id
                contractId
                constructionType {
                    id
                    code
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                parentId
                rootObjectId
                status
                name
                hasGuaranteedVolume
                objectSeasonDistributions {
                    id
                    contractSeason {
                        id
                        year
                    }
                    seasonValue
                }
                rationale
                order
                parentBasedOrder
            }
        }
    }
`);

export const bimWorkOrderChangeChaptersDataGql = graphql(`
    query bimWorkOrderChangeChapterPriceCounts(
        $workOrderChangeId: Long!
        $constructionTypeId: Int
        $workOrderRootObjectId: Long
        $workOrderChangeRootObjectId: Long
    ) {
        bimWorkOrderChangeChapterPriceCounts(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            workOrderRootObjectId: $workOrderRootObjectId
            workOrderChangeRootObjectId: $workOrderChangeRootObjectId
        ) {
            data {
                chapter
                pricesCount
            }
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            result
            message
            code
        }
    }
`);

export const bimWorkOrderChangePriceStatesGql = graphql(`
    query bimWorkOrderChangePriceStates(
        $workOrderChangeId: Long!
        $workOrderObjectId: Long
        $workOrderChangeObjectId: Long
        $chapter: BimChapterEnum!
    ) {
        bimWorkOrderChangePriceStates(
            workOrderChangeId: $workOrderChangeId
            workOrderObjectId: $workOrderObjectId
            workOrderChangeObjectId: $workOrderChangeObjectId
            chapter: $chapter
        ) {
            data {
                hasExcessCompletedTotalSMR
                hasExcessCompletedOthers
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimRemoveWorkOrderChangeObjectGql = graphql(`
    mutation bimRemoveWorkOrderChangeObject($workOrderChangeId: Long!, $contractObjectId: Long!) {
        bimRemoveWorkOrderChangeObject(workOrderChangeId: $workOrderChangeId, contractObjectId: $contractObjectId) {
            buttonText
            actionRequired
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);
